import { BadgeDesignTokens } from '@primeuix/themes/types/badge';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/badge/index.ts
const bg = componentCommon.badge;
const bgCs = componentColorScheme.badge;

export const BadgeTelekomDT: BadgeDesignTokens = {
  root: {
    borderRadius: t(bg.border.radius),
    fontSize: t(bg.font.size),
    fontWeight: tNum(bg.font.weight),
    minWidth: t(bg.min.width),
    height: t(bg.height),
  },
  dot: {
    size: t(bg.dot.size),
  },
  sm: {
    fontSize: t(bg.sm.font.size),
    minWidth: t(bg.sm.min.width),
    height: t(bg.sm.height),
  },
  lg: {
    fontSize: t(bg.lg.font.size),
    minWidth: t(bg.lg.min.width),
    height: t(bg.lg.height),
  },
  xl: {
    fontSize: t(bg.xl.font.size),
    minWidth: t(bg.xl.min.width),
    height: t(bg.xl.height),
  },
  primary: {
    background: t(bgCs.primary.background),
    color: t(bgCs.primary.color),
  },
  secondary: {
    background: t(bgCs.secondary.background),
    color: t(bgCs.secondary.color),
  },
  success: {
    background: t(bgCs.success.background),
    color: t(bgCs.success.color),
  },
  info: {
    background: t(bgCs.info.background),
    color: t(bgCs.info.color),
  },
  warn: {
    background: t(bgCs.warn.background),
    color: t(bgCs.warn.color),
  },
  danger: {
    background: t(bgCs.danger.background),
    color: t(bgCs.danger.color),
  },
  contrast: {
    background: t(bgCs.contrast.background),
    color: t(bgCs.contrast.color),
  },
};
